export default __webpack_public_path__ + "static/media/image-work-company-w@2x.cbc828ce.webp";